<template>
  <div class="vehicle-group-dashboard-rent" v-loading="loading">
    <FiltersBox
      class="mb16"
      :filterList="globalFilter.filterList"
      :model.sync="globalFilter.model"
      @change="handleGlobalFiltersChange"
    />

    <el-row class="mb16">
      <el-col :span="24">
        <!-- 出租漏斗 -->
        <FunnelCard
          :title="rentalFunnelData.title"
          :dataDesc="rentalFunnelData.dataDesc"
          :dateLabel="rentalFunnelData.dateLabel"
          :dateValue="rentalFunnelData.dateValue"
          :currentTab="rentalFunnelData.currentTab"
          :tabs="rentalFunnelData.tabs"
          :dataList="rentalFunnelData.dataList"
          @tabChange="handleFunnelCardTabChange"
        />
      </el-col>
    </el-row>

    <FiltersBox
      class="mb16"
      :filterList="localFilter.filterList"
      :model.sync="localFilter.model"
      @change="handleLocalFiltersChange"
    />

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 出租率 -->
        <LineChartCard
          :title="rentalRateChartData.title"
          :tooltip="rentalRateChartData.tooltip"
          :dataDesc="rentalRateChartData.dataDesc"
          :dataUpdateTime="rentalRateChartData.dataUpdateTime"
          :xAxis="rentalRateChartData.xAxis"
          :yAxis="rentalRateChartData.yAxis"
          :legendData="rentalRateChartData.legendData"
          :seriesData="rentalRateChartData.seriesData"
          :unit="rentalRateChartData.unit"
        />
      </el-col>
      <el-col :span="12">
        <!-- 空置率 -->
        <LineChartCard
          :title="vacancyRateChartData.title"
          :tooltip="vacancyRateChartData.tooltip"
          :dataDesc="vacancyRateChartData.dataDesc"
          :dataUpdateTime="vacancyRateChartData.dataUpdateTime"
          :xAxis="vacancyRateChartData.xAxis"
          :yAxis="vacancyRateChartData.yAxis"
          :legendData="vacancyRateChartData.legendData"
          :seriesData="vacancyRateChartData.seriesData"
          :unit="vacancyRateChartData.unit"
        />
      </el-col>
    </el-row>

    <el-row class="mb16" :gutter="16">
      <el-col :span="12">
        <!-- 续租率 -->
        <LineChartCard
          :title="renewalRateChartData.title"
          :tooltip="renewalRateChartData.tooltip"
          :dataDesc="renewalRateChartData.dataDesc"
          :dataUpdateTime="vacancyRateChartData.dataUpdateTime"
          :xAxis="renewalRateChartData.xAxis"
          :yAxis="renewalRateChartData.yAxis"
          :legendData="renewalRateChartData.legendData"
          :seriesData="renewalRateChartData.seriesData"
          :unit="renewalRateChartData.unit"
        />
      </el-col>
    </el-row>
  </div>
</template>
<script>
import moment from 'moment'
import FiltersBox from '@/bizComponents/Dashboard/filtersBox'
import FunnelCard from '@/bizComponents/Dashboard/cards/funnelCard/index.vue'
import LineChartCard from '@/bizComponents/Dashboard/cards/lineChartCard'
import {
  getVacancyRate,
  getRentalRate,
  getRentalFunnel,
  getRenewalRate,
} from '@/api/domain/vehicle'
import { getYAxisPercentMin } from '@/bizComponents/Dashboard/utils/function'

export default {
  components: {
    FiltersBox,
    FunnelCard,
    LineChartCard,
  },
  provide() {
    return {
      ratioConfig: this.globalFilter.model,
    }
  },
  data() {
    return {
      // 全局筛选
      globalFilter: {
        filterList: [
          {
            type: 'DeptSelect',
            label: '所属部门',
            name: 'deptId',
            options: [],
          },
          {
            type: 'select',
            label: '环比/同比',
            name: 'showRatio',
            options: [
              {
                label: '展示',
                value: true,
              },
              {
                label: '不展示',
                value: false,
              },
            ],
          },
        ],
        model: {
          deptId: this.$store.getters.userInfo.deptId || '',
          showRatio: true,
        },
      },
      // 局部筛选
      localFilter: {
        filterList: [
          {
            type: 'dateRange',
            label: '时间',
            name: 'date',
            t_1: true,
            pickerOptions: {
              tipConfig: {
                type: 1,
                daysNum: 365,
              },
              disabledDate: (time) => {
                return time.getTime() >= new Date(moment().format('YYYY-MM-DD 00:00:00')).getTime()
              },
            },
          },
          {
            type: 'select',
            label: '视角',
            name: 'type',
            options: [
              {
                label: '部门',
                value: 1,
              },
              {
                label: '车型',
                value: 2,
              },
            ],
          },
        ],
        model: {
          // 默认最近30天
          date: [
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000 - (30 * 24 * 60 * 60 * 1000))).format('YYYY-MM-DD HH:mm:ss'),
            moment(new Date(Date.now() - 24 * 60 * 60 * 1000)).format('YYYY-MM-DD HH:mm:ss'),
          ],
          type: 1,
        },
      },
      // 出租漏斗
      rentalFunnelData: {
        title: '出租漏斗',
        dataDesc: '该组数据仅展示T-1的日、周、月数据',
        dateLabel: '昨日数据',
        dateValue: '',
        currentTab: 1,
        tabs: [
          {
            label: '昨日',
            dateLabel: '昨日数据',
            value: 1,
          },
          {
            label: '当周平均',
            dateLabel: '当周内数据',
            value: 2,
          },
          {
            label: '当月平均',
            dateLabel: '当月内数据',
            value: 3,
          },
        ],
        dataList: [],
      },
      // 出租率
      rentalRateChartData: {
        title: '出租率(出租时长纬度)',
        tooltip: '日出租率=∑（单车当日处于已租状态下的总天数）/∑（单车当日处于待租或已租状态下的总天数）',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          splitNumber: 5,
          max: 100,
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 空置率
      vacancyRateChartData: {
        title: '空置率(出租时长纬度)',
        tooltip: '日空置率=100%-∑（单车当日处于已租状态下的总天数）/∑（单车当日处于待租或已租状态下的总天数）',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          splitNumber: 5,
          max: 100,
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      // 续租率
      renewalRateChartData: {
        title: '续租率',
        tooltip: '日续租率=截止当日，当月到期订单续签数量/当月到期订单数量*100%',
        dataDesc: 'T-1日数据',
        dataUpdateTime: '',
        xAxis: {
          data: [],
        },
        yAxis: {
          axisLabel: {
            show: true,
            interval: 'auto',
            formatter: '{value}%',
          },
          splitNumber: 5,
          max: 100,
          min: (value) => getYAxisPercentMin(value, 10),
        },
        legendData: [],
        seriesData: [],
        unit: '%',
      },
      loading: false,
    }
  },
  computed: {
    deptId() {
      return this.$store.getters.userInfo.deptId
    },
    params() {
      const { date } = this.localFilter.model
      const startDate = Array.isArray(date) ? moment(date[0]).format('YYYY-MM-DD') : ''
      const endDate = Array.isArray(date) ? moment(date[1]).format('YYYY-MM-DD') : ''
      return {
        deptIdList: this.globalFilter.model.deptId ? [this.globalFilter.model.deptId] : [],
        statCycle: this.rentalFunnelData.currentTab,
        type: this.localFilter.model.type,
        startDate,
        endDate,
      }
    },
  },
  watch: {
    deptId: {
      handler(val) {
        if (val) {
          this.globalFilter.model.deptId = val || ''
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.update()
  },
  methods: {
    update() {
      this.loading = true
      Promise.all([
        this.updateCardData(),
        this.updateChartData(),
      ]).finally(() => {
        this.loading = false
      })
    },
    updateCardData() {
      this.getRentalFunnelCard()
    },
    async updateChartData() {
      await Promise.all([
        this.getRentalRateChart(),
        this.getVacancyRateChart(),
        this.getRenewalRateChart(),
      ])
    },
    handleGlobalFiltersChange() {
      this.update()
    },
    handleLocalFiltersChange() {
      this.updateChartData()
    },
    handleFunnelCardTabChange(val) {
      this.rentalFunnelData.currentTab = val
      this.rentalFunnelData.dateLabel = this.rentalFunnelData.tabs[val - 1].dateLabel || ''
      this.updateCardData()
    },
    // 获取出租漏斗
    async getRentalFunnelCard() {
      const res = await getRentalFunnel(this.params)
      const { code, data } = res
      if (code === 1 && data) {
        // 已入库车辆
        const receivedNumberDayRatioList = [
          {
            name: '日环比',
            value: data.operableRateDayRadio,
          },
          {
            name: '周同比',
            value: data.operableRateWeekYoY,
          },
        ]
        const receivedNumberWeekRatioList = [
          {
            name: '周环比',
            value: data.operableRateWeekRadio,
          },
        ]
        const receivedNumberMonthRatioList = [
          {
            name: '月环比',
            value: data.operableRateMonthRadio,
          },
        ]
        const receivedNumberRatioList = [receivedNumberDayRatioList, receivedNumberWeekRatioList, receivedNumberMonthRatioList]

        // 可出租车辆
        const rentableNumberDayRatioList = [
          {
            name: '日环比',
            value: data.rentableRateDayRadio,
          },
          {
            name: '周同比',
            value: data.rentableRateWeekYoY,
          },
        ]
        const rentableNumberWeekRatioList = [
          {
            name: '周环比',
            value: data.rentableRateWeekRadio,
          },
        ]
        const rentableNumberMonthRatioList = [
          {
            name: '月环比',
            value: data.rentableRateMonthRadio,
          },
        ]
        const rentableNumberRatioList = [rentableNumberDayRatioList, rentableNumberWeekRatioList, rentableNumberMonthRatioList]

        // 已租车辆
        const rentedNumberDayRatioList = [
          {
            name: '日环比',
            value: data.rentedRateDayRadio,
          },
          {
            name: '周同比',
            value: data.rentedRateWeekYoY,
          },
        ]
        const rentedNumberWeekRatioList = [

          {
            name: '周环比',
            value: data.rentedRateWeekRadio,
          },
        ]
        const rentedNumberMonthRatioList = [
          {
            name: '月环比',
            value: data.rentedRateMonthRadio,
          },
        ]
        const rentedNumberRatioList = [rentedNumberDayRatioList, rentedNumberWeekRatioList, rentedNumberMonthRatioList]

        this.rentalFunnelData.dateValue = [data.dayCycle, data.weekCycle, data.monthCycle][this.rentalFunnelData.currentTab - 1] || ''
        this.rentalFunnelData.dataList = [
          {
            label: '可运营车辆',
            value: 1,
            showRatio: false,
          },
          {
            label: '已入库车辆',
            value: [data.operableRateOfDay, data.operableRateOfWeek, data.operableRateOfMonth][this.rentalFunnelData.currentTab - 1] || 0,
            ratioList: receivedNumberRatioList[this.rentalFunnelData.currentTab - 1],
          },
          {
            label: '可出租车辆',
            value: [data.rentableRateOfDay, data.rentableRateOfWeek, data.rentableRateOfMonth][this.rentalFunnelData.currentTab - 1] || 0,
            ratioList: rentableNumberRatioList[this.rentalFunnelData.currentTab - 1],
          },
          {
            label: '已租车辆',
            value: [data.rentedRateOfDay, data.rentedRateOfWeek, data.rentedRateOfMonth][this.rentalFunnelData.currentTab - 1] || 0,
            ratioList: rentedNumberRatioList[this.rentalFunnelData.currentTab - 1],
          },
        ]
      }
    },
    // 获取出租率
    async getRentalRateChart() {
      const res = await getRentalRate(this.params)
      const { code, data } = res
      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.rentalRateChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.rentalRateChartData.legendData = data.nameList || []
        this.rentalRateChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.localFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.rentalRateChartData.seriesData = this.rentalRateChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.rentalRateChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取空置率
    async getVacancyRateChart() {
      const res = await getVacancyRate(this.params)
      const { code, data } = res
      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.vacancyRateChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.vacancyRateChartData.legendData = data.nameList || []
        this.vacancyRateChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.localFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.vacancyRateChartData.seriesData = this.vacancyRateChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.vacancyRateChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
    // 获取续租率
    async getRenewalRateChart() {
      const res = await getRenewalRate(this.params)
      const { code, data } = res
      if (code === 1 && data) {
        const dataList = data.dataList || []
        this.renewalRateChartData.dataUpdateTime = data.updateTime || ''
        // 图例（公司名称 或 车型名称）
        this.renewalRateChartData.legendData = data.nameList || []
        this.renewalRateChartData.xAxis.data = dataList.map((item) => item.ds) || []
        // 是否公司视角
        const isCompanyView = this.localFilter.model.type === 1
        // 系列（公司列表 或 车辆列表）
        this.renewalRateChartData.seriesData = this.renewalRateChartData.legendData.map((item) => {
          return {
            // 系列名称: 公司名称 或 车型名称
            name: item,
            data: dataList.map((itm) => {
              const deptInfo = (itm.deptList || []).find((dept) => dept.deptName === item)
              const seriesInfoItem = (itm.seriesList || []).find((seriesInfo) => seriesInfo.modelName === item)
              // X轴数据（日期）
              const date = itm.ds
              // Y轴数据（比率）: 公司的 或 车型的
              const value = (((isCompanyView ? deptInfo?.rate : seriesInfoItem?.rate) || 0) * 100).toFixed(2)
              // 数据名称
              const dataTitle = this.renewalRateChartData.title
              // 环比/同比: 公司的 或 车型的
              const dayRadio = (isCompanyView ? deptInfo?.dayRadio : seriesInfoItem?.dayRadio) || 0
              const weekRadio = (isCompanyView ? deptInfo?.weekYoY : seriesInfoItem?.weekYoY) || 0
              return [
                date,
                value,
                {
                  dataTitle,
                  ratioList: [
                    {
                      name: '日环比',
                      value: dayRadio,
                    },
                    {
                      name: '周同比',
                      value: weekRadio,
                    },
                  ],
                },
              ]
            }),
          }
        })
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.mb16 {
  margin-bottom: 16px;
}
.mt24 {
  margin-top: 24px;
}
</style>
